// src/pages/MobileIntroHome.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * (Deprecated)
 * 기존 인트로 홈 화면 제거 목적.
 * 혹시 남아있는 링크/네비게이션이 이 페이지로 들어오더라도
 * 즉시 /m/home 으로 이동시킨다.
 */
export default function MobileIntroHome() {
  const nav = useNavigate();

  useEffect(() => {
    nav("/m/home", { replace: true });
  }, [nav]);

  // UX 깔끔하게 빈 화면
  return null;
}
